import { EntriesConfig } from "./entriesConfig";
import { RunsConfig } from "./runsConfig";

export class EventTypeConfiguration {
    entries: EntriesConfig;
    runs: RunsConfig;
    isJackpot: boolean;

    constructor() {
        this.entries = new EntriesConfig();
        this.runs = new RunsConfig();
    }
}


// WEBPACK FOOTER //
// ./src/model/eventTypeConfiguration.ts